import * as PropTypes from "prop-types"
import React, { Component } from "react"
import { Dropdown, Form } from "semantic-ui-react"

class DropdownQuantities extends Component {

  state = {
    count:0,
  }

  render() {
    let { product, onChange, selection } = this.props
    const options = product.quantities.map( q => {
      return {
        value: q.map_desc_id,
        key  : `${q.map_desc_id}${q.multi}`,
        text : `${q.des} (${q.multi})`
      }
    } )
    return <div className="DropdownQuantities">
      <Dropdown
        fluid
        value={product.map_desc_id}
        selection
        options={options}
        text={`${product.unit_desc} (${product.unit_multi})`}
        onChange={( event, data ) => {
          const { value } = data
          if ( product.onChange ) {
            let ok = product.onChange( product )
            if ( !ok ) {
              return false
            }
          }
          let q = product.quantityById[ value ]
          console.log( "q", q )
          product.unit_multi = q.multi
          product.unit_id = q.map_desc_id
          product.count = Number( product.count )
          // if ( shop.config.checkout.limitToStock ) product.count = getProductCount( product )
          onChange( { product, count: product.count } )
        }
        }
      />
    </div>
  }
}

DropdownQuantities.propTypes = {
  product  : PropTypes.any,
  onChange : PropTypes.any,
  selection: PropTypes.any
}

export default DropdownQuantities



// WEBPACK FOOTER //
// ./src/components/Product/DropdownQuantities.js